import coin from "./json/coin.json"
import portfolio from "./json/portfolio.json"
import milestones from "./json/milestones.json"
import howItWorksStart from "./json/how_it_works_start.json"
import howItWorksLoop from "./json/how_it_works_loop.json"

$(() => {
  const load = (id, name, loop, autoplay) => {
    /* global lottie */
    const anim = lottie.loadAnimation({
      container: document.getElementById(name),
      renderer: "svg",
      loop,
      autoplay,
      animationData: id,
      name,
    })
    anim.setSpeed(0.75)
    return anim
  }
  $(document).on("scroll:coin", () => {
    load(coin, "coin", true, true)
  })

  $(document).on("scroll:charts", () => {
    load(portfolio, "portfolio-anim", false, true)
    load(milestones, "milestones", false, true)
  })

  $(document).on("scroll:ico", () => {
    const animStart = load(howItWorksStart, "how-it-works-anim", false, true)
    animStart.addEventListener("complete", () => {
      lottie.destroy("how-it-works-anim")
      load(howItWorksLoop, "how-it-works-anim", true, true)
    })
  })
})



// WEBPACK FOOTER //
// ./src/blocks/animations/animations.js